import type { ReactElement, SVGProps } from 'react';

export function MinusOutlinedCheckboxIcon(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg fill="currentColor" viewBox="0 0 8 8" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect height="1.41935" rx=".709677" width="8" y="3.29028" />
    </svg>
  );
}
